module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAABCAYAAAAGu30GAAAAKElEQVR4AWNYsGDxzKGI33/82kBv/G7TtknDD4/iUTyKR/EoHog6BQBKxHiWTk9kWQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids/selfcare_sidenav+maincontainer.png
// module id = 353
// module chunks = 0